import type {
  Address,
  CepResponseProps,
} from 'src/components/checkout/steps/shipping/types'

export function isValidCepLookup(
  data: CepResponseProps | null
): data is CepResponseProps {
  if (!data) {
    return false
  }

  return Boolean(data.city?.trim() && data.state?.trim())
}

export function formatGuestAddressPreview(address: {
  street?: string | null
  neighborhood?: string | null
  city?: string | null
  state?: string | null
}): string {
  const streetAndNeighborhood = [address.street, address.neighborhood]
    .map((value) => value?.trim())
    .filter(Boolean)
    .join(', ')

  const cityState = [address.city, address.state]
    .map((value) => value?.trim())
    .filter(Boolean)
    .join(' - ')

  return [streetAndNeighborhood, cityState].filter(Boolean).join(', ')
}

export function shouldSkipGuestAddressPersistence(address: {
  street?: string | null
}): boolean {
  return !address.street?.trim()
}

export function buildGuestPostalOnlyAddress(
  lookup: CepResponseProps,
  postalCodeInput: string
): Address {
  return {
    addressType: 'residential',
    receiverName: '',
    postalCode: postalCodeInput.replace(/\D/g, ''),
    city: lookup.city ?? '',
    state: lookup.state ?? '',
    country: lookup.country ?? 'BRA',
    street: lookup.street ?? '',
    neighborhood: lookup.neighborhood ?? '',
    complement: '',
  }
}
